import React, { FC, useCallback } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Avatar, Button, Col, Drawer, Row, Typography } from 'components';
import { AssignedUser } from 'pages/admin/roles/useRoles';
import { ADMIN_ROUTES } from 'constants/routes';
import { useNavigate } from 'react-router-dom';

interface IAllWebsiteDrawer {
  onExpand: () => void;
  drawerState: boolean;
  data?: AssignedUser[];
}

export const AssignedUsersDrawer: FC<IAllWebsiteDrawer> = React.memo((props) => {
  const { onExpand, drawerState, data } = props;
  const navigate = useNavigate();
  const onRedirectToUser = useCallback(
    (value: string) => {
      navigate(`${ADMIN_ROUTES.users.view}/${value}/account`);
    },
    [navigate]
  );
  return (
    <Drawer
      closeIcon={null}
      placement="left"
      width={471}
      open={drawerState}
      onClose={() => onExpand()}
      styles={{
        header: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      }}
      title={'Assigned Users'}
    >
      <div style={{ position: 'absolute', right: 16, top: 16 }}>
        <Button icon={<CloseOutlined />} onClick={() => onExpand()} type="text" />
      </div>
      <Row gutter={[0, 12]}>
        {data?.map((user) => (
          <Col key={user.id} span={24}>
            <Row align={'middle'} className={'gap-10'} wrap={false}>
              <Avatar
                size={32}
                src={user.files?.AVATAR}
                style={{
                  backgroundColor: '#CCF6DA',
                  border: '1px solid #E1E4EA',
                  fontSize: '12px',
                  color: '#222530',
                  height: '32px',
                  width: '32px',
                  minWidth: '32px',
                }}
              >
                {user.firstName?.charAt(0)}
                {user.lastName?.charAt(0)}
              </Avatar>
              <Typography.Text
                underline
                className={'font-weight-600'}
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => onRedirectToUser(user.id)}
              >
                {user.firstName} {user.lastName}
              </Typography.Text>
            </Row>
          </Col>
        ))}
      </Row>
    </Drawer>
  );
});
